// Estilo del panel lateral por negocio: 'violet' (morado, por defecto) o
// 'lavender' (lavanda). Se guarda en el navegador (por ahora por dispositivo,
// por negocio). Paso 2: persistir en la base de datos.
import { getNegocioId } from './negocioActual';

const clave = () => {
  try { return `kontrol_panel_${getNegocioId()}`; } catch { return null; }
};

export function obtenerPanel() {
  // Por defecto lavanda (marca Automatika). Solo 'violet' si el negocio lo eligió.
  try {
    const k = clave();
    return (k && localStorage.getItem(k)) === 'violet' ? 'violet' : 'lavender';
  } catch {
    return 'lavender';
  }
}

export function guardarPanel(estilo) {
  try {
    const k = clave();
    if (k) localStorage.setItem(k, estilo === 'lavender' ? 'lavender' : 'violet');
  } catch { /* almacenamiento no disponible */ }
}

// Aplica el tema al documento (el CSS reacciona a [data-panel="lavender"]).
export function aplicarPanel(estilo) {
  const root = document.documentElement;
  if (estilo === 'lavender') root.setAttribute('data-panel', 'lavender');
  else root.removeAttribute('data-panel');
}
